import React, { useEffect, useState } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import ProductTableDetails from '../../.././components/ProductTableDetails';

// Media
import SolidStateImage from './media/BatterySSB.jpg';
import SmartBox from './media/SmartBox01.jpg';
import Battery from './media/Battery01.jpg';
import Rex180 from './media/REX180.jpg';
import VCU from './media/VCU.png';
import BMS from './media/BMS.png';
import AppScreen01 from './media/AppScreen01.png';
import AppScreen02 from './media/AppScreen02.png';
import AppScreen03 from './media/AppScreen03.png';

// SSB Icons
import SSB_Fireproof from './icons/4_SSB_FIREPROOF.png';
import SSB_HeavyDuty from './icons/4_SSB_HEAVY_DUTY.png';
import SSB_LightPowerful from './icons/4_SSB_LIGHT_AND_POWERFUL.png';
import SSB_RemoteDiagnostic from './icons/4_SSB_REMOTE_DIAGNOSTIC.png';

// Safeli Icons
import HeavyDuty from './icons/1_SAFELI_HEAVY_DUTY.png';
import Fireproof from './icons/1_SAFELI_FIREPROOF.png';
import RemoteDiagnostic from './icons/1_SAFELI_REMOTE_DIAGNOSTIC.png';
import LightAndPowerful from './icons/1_SAFELI_LIGHT_AND_POWERFUL.png';

// SmartBox Icons
import AlwaysHome from './icons/2_SMARTBOX_ALWAYS_HOME.png';
import AlwaysSea from './icons/2_SMARTBOX_ALWAYS_SEA.png';
import Modularity from './icons/2_SMARTBOX_MODULARITY.png';
import Ridondancy from './icons/2_SMARTBOX_RIDONDANCY.png';

// REX180 ICONS
import AltaEfficienza from './icons/3_REX180_ALTA_EFFICIENZA.png';
import HighPerformance from './icons/3_REX180_HIGH_PERFORMANCE.png';
import LowNoise from './icons/3_REX180_LOW_NOISE.png';

// Icone
import { FaCarBattery } from 'react-icons/fa';
import { HiChip } from 'react-icons/hi';
import { RiRemoteControlFill } from 'react-icons/ri';
import { AiOutlineCodeSandbox } from 'react-icons/ai';
import { ImPower } from 'react-icons/im';
import { BsTable } from 'react-icons/bs';

function Prodotti() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeProduct, setActiveProduct] = useState('SolidStateBattery');
  const [activeProductDetails, setActiveProductDetails] = useState();

  const AppFeatures = [
    {
      icon: <ImPower size={24} className="fill-gray-900" />,
      title: 'GPS',
      text: 'Monitora la posizione, la velocità e la direzione dell’imbarcazione.',
    },
    {
      icon: <FaCarBattery size={24} className="fill-gray-900" />,
      title: 'Gestione della Batteria',
      text: "Visualizza lo stato di carica attuale dell'imbarcazione, il tempo di ricarica rimanente e tutte le informazioni utili sullo stato di salute della batteria senza dover essere vicino all'imbarcazione.",
    },
    {
      icon: <HiChip size={24} className="fill-gray-900" />,
      title: 'Tracking di viaggio',
      text: 'Monitora i viaggi effettuati, il percorso fatto la velocità di navigazione e l’energia utilizzata.',
    },
    {
      icon: <AiOutlineCodeSandbox size={24} className="fill-gray-900" />,
      title: 'Registro di ricarica',
      text: 'Ottenete una panoramica completa della vostra ricarica. Quando, dove e quanto hai ricaricato.',
    },
    {
      icon: <RiRemoteControlFill size={24} className="fill-gray-900" />,
      title: 'Geofencing',
      text: "Ricevi una notifica se l’imbarcazione esce da un'area predefinita o segnala dei problemi.",
    },
  ];

  const Products = [
    {
      product_name: 'SolidStateBattery',
      product_title: 'Batteria Solid State',
      product_subtitle: "Batteria ad alta densità energetica",
      product_description:
        'La prima batteria Solid-state heavy duty e ad altissima densità energetica, progettata per l’ambiente marino.',
      product_image: SolidStateImage,
      product_features: [
    {
      icon: SSB_LightPowerful,
      title: 'LEGGERA E POTENTE',
      text: 'La più alta densità energetica mai vista nel settore marino.',
    },
    {
      icon: SSB_Fireproof,
      title: 'SICUREZZA',
      text: 'Il più alto livello di sicurezza rispetto alle celle convenzionali LFP o NMC.',
    },
    {
      icon: SSB_RemoteDiagnostic,
      title: 'DIAGNOSTICA REMOTA',
      text: 'Diagnostica remota, anche tramite smartphone.',
    },
    {
      icon: SSB_HeavyDuty,
      title: 'HEAVY DUTY',
      text: 'Batteria completamente progettata per la propulsione marina heavy duty.',
    },
  ],
  productDetails: [
    { 'Tensione nominale': ['355 V'] },
    { 'Tensione massima': ['425 V'] },
    { 'Energia totale': ['75 kWh'] },
    { 'Dimensioni (LxWxH)': ['2018 x 845 x 145 mm'] },
    { 'Peso': ['312 kg'] },
    { 'Densità energetica': ['>250 Wh/kg'] },
    { 'Ricarica standard': ['1C'] },
    { 'Ricarica veloce': ['1.5C'] },
    { 'Scarica standard': ['1C'] },
    { 'Scarica veloce': ['2C'] },
    { 'Comunicazione': ['CANBUS control & monitoring'] },
    { 'Doppia tensione': ['Disponibile versione 800V'] },
      ],
    },

    {
      product_name: 'SAFELI',
      product_title: 'SafeLi',
      product_subtitle: 'Batteria Fireproof',
      product_description:
        "La prima batteria al mondo Fireproof, ad alta densità di potenza, specifica per l'ambiente marino",
      product_image: Battery,
      product_features: [
        {
          icon: HeavyDuty,
          title: 'HEAVY DUTY',
          text: 'Batteria innovativa progettata specificamente per la propulsione marina per uso intensivo',
        },
        {
          icon: Fireproof,
          title: 'FIREPROOF',
          text: 'Dotato di un innovativo sistema di isolamento antincendio',
        },
        {
          icon: RemoteDiagnostic,
          title: 'REMOTE DIAGNOSTIC',
          text: 'Dotata di diagnostica da remoto tramite smartphone',
        },
        {
          icon: LightAndPowerful,
          title: 'LIGHT & POWERFUL',
          text: 'Alta densità di energia in un case compatto',
        },
      ],
      productDetails: [
        {
          'Nominal Voltage': ['400 VDC'],
        },
        {
          'Min - Max Voltage': ['320-450 VDC'],
        },
        {
          'Available Energy': ['83 kWh'],
        },
        {
          'Standard Charge': ['2C'],
        },
        {
          'Fast Charge': ['4C'],
        },
        {
          'Standard Discharge': ['3C'],
        },
        {
          'Fast Discharge': ['6C'],
        },
        {
          Certifications: ['DNV-GL (on going)'],
        },
        {
          BMS: ['Propriety eDriveLab'],
        },
        {
          'Charge/Discharge operating temp': ['-20/45°C'],
        },
        {
          'Life cycles': ['>6000'],
        },
        {
          'Remote diagnostic': ['PC/Smartphone'],
        },
        {
          'Dimensions (L x W x H)': ['985 x 880 x 660 mm'],
        },
        {
          Weight: ['550 kg'],
        },
      ],
    },
    {
      product_name: 'Smartbox',
      product_title: 'Smartbox',
      product_subtitle: 'Powertrain Management System',
      product_description:
        'È il fulcro del Powertrain che controlla e gestisce l’erogazione di potenza',
      product_image: SmartBox,
      product_features: [
        {
          icon: Modularity,
          title: 'MODULARITÀ',
          text: 'E’ un prodotto customizzabile  che che viene incontro alle esigenze delle richieste dell’applicazione',
        },
        {
          icon: AlwaysHome,
          title: 'ALWAYS HOME',
          text: 'Sistema progettato per una maggiore affidabilità che non vi lascerà mai soli',
        },
        {
          icon: AlwaysSea,
          title: 'ALWAYS SEA',
          text: "Sistema innovativo di gestione dell'energia",
        },
        {
          icon: Ridondancy,
          title: 'RIDONDANZA',
          text: 'Una maggiore affidabilità del sistema per operare in qualsiasi condizione',
        },
      ],
      productDetails: [
        {
          'Operating Voltage range': ['300-450 VDC'],
        },
        {
          'Control-Unit and propriety control software': '',
        },
        {
          'Integrated DC-DC 12V 3kW output': '',
        },
        {
          'Total control security system': '',
        },
        {
          'Liquid cooled': '',
        },
        {
          'Dimensions (L x W x H)': ['691 x 652 x 470 mm'],
        },
        {
          Weight: ['80 kg'],
        },
        {
          Certifications: ['RINA'],
        },
        {
          'Up to 4 inverters': '',
        },
        {
          'Up to 900kW Max output power': '',
        },
        {
          'isometer integrated': '',
        },
      ],
    },
    {
      product_name: 'REX180',
      product_title: 'REX180',
      product_subtitle: 'Range Extender',
      product_description:
        "Il sistema di generazione dell'energia che migliorerà la vostra esperienza di navigazione, sentendo solo il rumore delle onde",
      product_image: Rex180,
      product_features: [
        {
          icon: Modularity,
          title: 'MODULARITÀ',
          text: 'E’ un prodotto customizzabile che che viene incontro alle esigenze delle richieste dell’applicazione',
        },
        {
          icon: HighPerformance,
          title: 'PROPULSIONE AD ALTE PERFORMANCE',
          text: 'Range Extender compatto e potente, progettato per la propulsione',
        },
        {
          icon: AltaEfficienza,
          title: 'ALTA EFFICIENZA',
          text: 'Minimizza il consumo di carburante, utilizzando sempre il sistema al massimo della sua efficienza',
        },
        {
          icon: LowNoise,
          title: 'BASSA RUMOROSITÀ',
          text: "Abbattimento del rumore e delle vibrazioni per un'esperienza di navigazione ottimale",
        },
      ],
      productDetails: [
        {
          'Nominal Output Voltage': ['350-450 Vdc'],
        },
        {
          'Output Power Max': ['180 kW'],
        },
        {
          'eDriveLAB Control Unit': [
            'Sistema di controllo automatico eDriveLAB',
          ],
        },
        {
          Certifications: ['CE (on going)'],
        },
        {
          'Dimensions (L x W x H)': ['1164 X 907 X 907 mm'],
        },
        {
          Weight: ['650 kg'],
        },
        {
          'Controllo di velocità': '',
        },
        {
          'Strategia per minimizzare i consumi': '',
        },
      ],
    },
    {
      product_name: 'VCU eDriveLAB',
      product_title: 'VCU eDriveLAB',
      product_subtitle: 'Vehicle Control Unit proprietaria',
      product_description: '',
      product_image: VCU,
      product_features: [
        {
          // icon: Modularity,
          // title: '?',
          text: 'Centralina general-purpose per il controlo di qualsiasi applicazione elettrica/ibrida o veicolo',
        },
        {
          // icon: HighPerformance,
          // title: '?',
          text: 'Elevato numero di input/output e funzionalità',
        },
        {
          // icon: AltaEfficienza,
          // title: '?',
          text: 'Implementazione facile e veloce dei nostri controlli proprietari, con codice autogenerato',
        },
        {
          // icon: LowNoise,
          // title: '?',
          text: 'Comunicazione CANBUS automotive, J1939, custom',
        },
      ],
    },
    {
      product_name: 'BMS eDriveLAB',
      product_title: 'BMS eDriveLAB',
      product_subtitle:
        'Abbiamo sviluppato un sistema proprietario di gestione della batteria',
      product_description: '',
      product_image: BMS,
      product_features: [
        {
          // icon: Modularity,
          // title: '?',
          text: 'Architettura modulare: possiamo adattarci a qualsiasi tipo di configurazione della batteria ',
        },
        {
          // icon: HighPerformance,
          // title: '?',
          text: 'Sistema autoalimentato, con software di controllo proprietario',
        },
        {
          // icon: AltaEfficienza,
          // title: '?',
          text: 'CAN standard di comunicazione automobilistica: J1939 ISO11898',
        },
        {
          // icon: LowNoise,
          // title: '?',
          text: 'Funzione di sicurezza conforme alle normative automobilistiche: interlock, isometer, gestione celle, diagnostica attiva, ecc...',
        },
      ],
    },
  ];

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="w-full bg-white h-fit">
      {/* Container */}

      {/* Desktop - Nuova versione grafica */}

      <div className="container mx-auto">
        {/* Dynamic Products - V2 */}

        <p className="px-10 pt-10 text-4xl font-bold text-gray-800">
          I nostri prodotti
        </p>

        {Products.map((product, id) => (
          <section
            id={id}
            className={`hidden gap-10 p-10 bg-white rounded-xl ${
              id % 2 === 0 ? 'md:flex' : 'md:flex md:flex-row-reverse'
            }`}
          >
            <div className="basis-1/2">
              <div className="">
                <div className="border-l-8 border-l-sky-400">
                  <div className="ml-2.5 border-b-2 text-6xl font-medium italic pb-2 max-w-fit">
                    {product.product_title}
                  </div>
                  <div className="ml-2.5 text-2xl pt-2">
                    {product.product_subtitle}
                  </div>
                </div>
                <div className="flex flex-col justify-between gap-8 mt-10">
                  {product.product_features &&
                    product.product_features.map((feature, id) => (
                      <div
                        id={id}
                        className={`${
                          feature.title ? '' : 'border-l-8 border-blue-500'
                        } flex items-center gap-4`}
                      >
                        <img src={feature.icon} alt="" className="h-20" />
                        <div>
                          <p className="font-bold">{feature.title}</p>
                          <p>{feature.text}</p>
                        </div>
                      </div>
                    ))}
                  {product.productDetails ? (
                    <button
                      onClick={() => {
                        setActiveProduct(product.product_title);
                        setActiveProductDetails(product.productDetails);
                        setIsOpen(true);
                        console.log(activeProductDetails);
                      }}
                      className="flex items-center justify-center gap-4 p-3 transition-all border-2 border-gray-700 rounded-lg hover:bg-gray-700 hover:text-white w-fit"
                    >
                      <BsTable />
                      Scheda Tecnica
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="p-10 my-auto border-gray-300 basis-1/2">
              <div className="flex flex-col items-center">
                <img src={product.product_image} alt="" className="max-w-lg" />
                <p className="mt-4 text-xl font-bold text-center">
                  {product.product_description}
                </p>
              </div>
            </div>
          </section>
        ))}

        {/* Mobile - Nuova versione grafica */}
        {Products &&
          Products.map((product, id) => (
            <section className="p-10 md:hidden">
              <div className="border-l-8 border-l-sky-400">
                <div className="ml-2.5 border-b-2 text-4xl font-medium italic pb-2 max-w-fit">
                  {product.product_title}
                </div>
                <div className="ml-2.5 text-2xl pt-2">
                  {product.product_subtitle}
                </div>
              </div>
              <img
                src={product.product_image}
                alt=""
                className="w-full max-w-lg mx-auto mt-8"
              />
              <p className="mt-8 text-xl">{product.product_description}</p>
              <div className="flex flex-col justify-between gap-8 mt-10">
                {product.product_features &&
                  product.product_features.map((feature, id) => (
                    <div
                      id={id}
                      className={`flex items-center gap-4 ${
                        feature.title ? '' : 'border-l-8 border-blue-500'
                      }`}
                    >
                      <img src={feature.icon} alt="" className="h-20" />
                      <div>
                        <p className="font-bold">{feature.title}</p>
                        <p>{feature.text}</p>
                      </div>
                    </div>
                  ))}
                {product.productDetails ? (
                  <button
                    onClick={() => {
                      setActiveProduct(product.product_title);
                      setActiveProductDetails(product.productDetails);
                      setIsOpen(true);
                      console.log(activeProductDetails);
                    }}
                    className="flex items-center justify-center w-full gap-4 p-3 transition-all border-2 border-gray-700 rounded-lg hover:bg-gray-700 hover:text-white"
                  >
                    <BsTable />
                    Scheda Tecnica
                  </button>
                ) : null}
              </div>
            </section>
          ))}

        {/* INIZIO -- Edrive Lab App */}
        <section className="gap-8 p-10">
          <div className="w-full">
            <h2 className="text-4xl font-bold">Seaviewer App</h2>
            <p className="my-4">
              L’App Seaviewer è sempre connessa. Tieni sotto controllo le
              Informazioni della tua imbarcazione in tempo reale e a portata di
              mano.
            </p>
            <div className="hidden justify-evenly lg:flex">
              <img src={AppScreen01} alt="" className="h-auto max-h-[600px]" />
              <img src={AppScreen02} alt="" className="h-auto max-h-[600px]" />
              <img src={AppScreen03} alt="" className="h-auto max-h-[600px]" />
            </div>
            <div className="block lg:hidden">
              <Splide aria-label="My Slider">
                <SplideSlide>
                  <img src={AppScreen01} alt="" className="" />
                </SplideSlide>
                <SplideSlide>
                  <img src={AppScreen02} alt="" className="" />
                </SplideSlide>
                <SplideSlide>
                  <img src={AppScreen03} alt="" className="" />
                </SplideSlide>
              </Splide>
            </div>
            <div className="grid grid-cols-1 gap-4 mt-10 md:mt-4 md:grid-cols-2 lg:grid-cols-3">
              {AppFeatures &&
                AppFeatures.map((punto, id) => (
                  <div
                    key={id}
                    className="flex flex-col items-start gap-4 p-4 bg-gray-900 grow rounded-xl"
                  >
                    <span className="p-6 bg-white rounded-lg ">
                      {punto.icon}
                    </span>
                    <div class="mt-2">
                      <h2 class="text-lg font-bold text-white">
                        {punto.title}
                      </h2>
                      <p class="mt-1 mb-3 text-sm text-gray-300">
                        {punto.text}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>

        {/* Dashboard Coming Soon... */}

        <section className="mx-10 mb-10">
          <div className="flex flex-col items-center justify-center w-full overflow-hidden bg-gray-200 h-96 rounded-2xl">
            <p className="absolute z-10 font-bold text-center text-white sm:text-4xl">
              Dashboard Dedicata
              <br />
              <span className="italic font-normal sm:text-2xl">
                Coming Soon...
              </span>
            </p>

            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
              alt=""
              className="relative blur-2xl"
            />
          </div>
        </section>

        {/* Dialog con tabella prodotto */}
        <ProductTableDetails
          productName={activeProduct}
          productDetails={activeProductDetails}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
        />
      </div>
    </div>
  );
}

export default Prodotti;
